import { render, staticRenderFns } from "./ProfileViewers.vue?vue&type=template&id=6489dfe8&"
import script from "./ProfileViewers.vue?vue&type=script&lang=js&"
export * from "./ProfileViewers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports